import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import StartNewCase from '../views/StartNewCase.vue'
import RunningCases from '../views/RunningCases.vue'
import MyTasks from '../views/MyTasks.vue'
import TeamTasks from '../views/TeamTasks.vue'
import UnassignedTasks from '../views/UnassignedTasks.vue'
import AllTasks from '../views/AllTasks.vue'
import HistoricCases from '../views/HistoricCases.vue'
import ViewTask from '../views/ViewTask.vue'
import ViewCaseHistory from '../views/ViewCaseHistory.vue'
import Admin from '../views/Admin.vue'
import FormBuilder from '../views/FormBuilder.vue'
import BuildForm from '../views/BuildForm.vue'
import ProcessDesigner from '../views/ProcessDesigner.vue'
import BuildProcess from '../views/BuildProcess.vue'
import Templates from '../views/Templates.vue'
import TemplateEditor from '../views/TemplateEditor.vue'
import Documents from '../views/Documents.vue'
import DatabaseTables from '../views/DatabaseTables.vue'
import ViewTable from '../views/ViewTable.vue'
import External from '../views/External.vue'
import ThankYou from '../views/ThankYou.vue'
import OAuthCallback from '../views/OAuthCallback.vue'
import Reports from '../views/Reports.vue'
import BuildReport from '../views/BuildReport.vue'
import ViewReport from '../views/ViewReport.vue'
import Support from '../views/Support.vue'
import ChangePassword from '../views/ChangePassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/external',
    name: 'External',
    component: External
  },
  {
    path: '/changepw',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou
  },
  {
    path: '/oauthcallback',
    name: 'OAuthCallback',
    component: OAuthCallback
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: Home,
    meta: {
      title: 'MAIN_MENU.ITEMS.DASH',
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: 'MAIN_MENU.ITEMS.ADMIN',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents,
    meta: {
      title: 'MAIN_MENU.ITEMS.DOCS',
      requiresAuth: true
    }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: Templates,
    meta: {
      title: 'MAIN_MENU.ITEMS.TEMPLATES',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/template-editor',
    name: 'TemplateEditor',
    component: TemplateEditor,
    meta: {
      title: 'MAIN_MENU.ITEMS.TEMPLATE_EDITOR',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/form-builder',
    name: 'FormBuilder',
    component: FormBuilder,
    meta: {
      title: 'MAIN_MENU.ITEMS.FORM_BUILDER',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/build-form',
    name: 'BuildForm',
    component: BuildForm,
    meta: {
      title: 'MAIN_MENU.ITEMS.BUILD_FORM',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/process-designer',
    name: 'ProcessDesigner',
    component: ProcessDesigner,
    meta: {
      title: 'MAIN_MENU.ITEMS.PROCESS_DESIGNER',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/build-process',
    name: 'BuildProcess',
    component: BuildProcess,
    meta: {
      title: 'MAIN_MENU.ITEMS.BUILD_PROCESS',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/database-tables',
    name: 'DatabaseTables',
    component: DatabaseTables,
    meta: {
      title: 'MAIN_MENU.ITEMS.DB_TABLES',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/view-table',
    name: 'ViewTable',
    component: ViewTable,
    meta: {
      title: 'MAIN_MENU.ITEMS.DB_VIEW_TABLE',
      requiresAuth: true,
      requiresDevPlus: true
    }
  },
  {
    path: '/start-new-case',
    name: 'StartNewCase',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: StartNewCase,
    meta: {
      title: 'MAIN_MENU.ITEMS.START_CASE',
      requiresAuth: true
    }
  },
  {
    path: '/running-cases',
    name: 'RunningCases',
    component: RunningCases,
    meta: {
      title: 'MAIN_MENU.ITEMS.RUNNING_CASES',
      requiresAuth: true,
      requiresSuperPlus: true
    }
  },
  {
    path: '/my-tasks',
    name: 'MyTasks',
    component: MyTasks,
    meta: {
      title: 'MAIN_MENU.ITEMS.MY_TASKS',
      requiresAuth: true
    }
  },
  {
    path: '/team-tasks',
    name: 'TeamTasks',
    component: TeamTasks,
    meta: {
      title: 'MAIN_MENU.ITEMS.TEAM_TASKS',
      requiresAuth: true,
      requiresManagerPlus: true
    }
  },
  {
    path: '/unassigned-tasks',
    name: 'UnassignedTasks',
    component: UnassignedTasks,
    meta: {
      title: 'MAIN_MENU.ITEMS.UNASSIGNED_TASKS',
      requiresAuth: true
    }
  },
  {
    path: '/all-tasks',
    name: 'AllTasks',
    component: AllTasks,
    meta: {
      title: 'MAIN_MENU.ITEMS.ALL_TASKS',
      requiresAuth: true,
      requiresSuperPlus: true
    }
  },
  {
    path: '/historic-cases',
    name: 'HistoricCases',
    component: HistoricCases,
    meta: {
      title: 'MAIN_MENU.ITEMS.HISTORIC_CASES',
      requiresAuth: true,
      requiresSuperPlus: true
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      title: 'MAIN_MENU.ITEMS.REPORTS',
      requiresAuth: true
    }
  },
  {
    path: '/build-report',
    name: 'BuildReport',
    component: BuildReport,
    meta: {
      title: 'MAIN_MENU.ITEMS.BUILD_REPORT',
      requiresAuth: true,
      requiresManagerPlus: true
    }
  },
  {
    path: '/view-report',
    name: 'ViewReport',
    component: ViewReport,
    meta: {
      title: 'MAIN_MENU.ITEMS.VIEW_REPORT',
      requiresAuth: true
    }
  },
  {
    path: '/view-task',
    name: 'ViewTask',
    component: ViewTask,
    meta: {
      title: 'MAIN_MENU.ITEMS.VIEW_TASK',
      requiresAuth: true
    }
  },
  {
    path: '/view-case-history',
    name: 'ViewCaseHistory',
    component: ViewCaseHistory,
    meta: {
      title: 'MAIN_MENU.ITEMS.VIEW_CASE_HISTORY',
      requiresAuth: true,
      requiresSuperPlus: true
    }
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: {
      title: 'MAIN_MENU.ITEMS.SUPPORT_REQUEST',
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history', // For docker
  base: process.env.BASE_URL, // For docker
  routes
})

// Nav guards
router.beforeEach((to, from, next) => {

  // Check for requiresAuth guard
  if(to.matched.some(record => record.meta.requiresAuth)) {
    // Check if not logged in
    if(!store.state.isLoggedIn) {
      // Go to login page
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }else {
      // Check for requiresAdmin guard
      if(to.matched.some(record => record.meta.requiresAdmin)) {
        // Check is user is not an admin
        if(!store.state.isAdmin) {
          // Got to home page
          next({
            path: '/dashboard',
            query: {
              redirect: to.fullPath
            }
          });
        }else {
          // Proceed to the route
          next();
        }
      }else {
        // Proceed to the route
        next();
      }

      // Check for requiresDevPlus guard
      if(to.matched.some(record => record.meta.requiresDevPlus)) {
        // Check is user is not an admin or developer
        if(!store.state.isAdmin && !store.state.isDeveloper) {
          // Got to home page
          next({
            path: '/dashboard',
            query: {
              redirect: to.fullPath
            }
          });
        }else {
          // Proceed to the route
          next();
        }
      }else {
        // Proceed to the route
        next();
      }

      // Check for requiresSuperPlus guard
      if(to.matched.some(record => record.meta.requiresSuperPlus)) {
        // Check is user is not an admin or developer or supervisor
        if(!store.state.isAdmin && !store.state.isDeveloper && !store.state.isSupervisor) {
          // Got to home page
          next({
            path: '/dashboard',
            query: {
              redirect: to.fullPath
            }
          });
        }else {
          // Proceed to the route
          next();
        }
      }else {
        // Proceed to the route
        next();
      }

      // Check for requiresManagerPlus guard
      if(to.matched.some(record => record.meta.requiresManagerPlus)) {
        // Check is user is not an admin, developer, supervisor or manager
        if(!store.state.isAdmin && !store.state.isDeveloper && !store.state.isSupervisor && !store.state.isManager) {
          // Got to home page
          next({
            path: '/dashboard',
            query: {
              redirect: to.fullPath
            }
          });
        }else {
          // Proceed to the route
          next();
        }
      }else {
        // Proceed to the route
        next();
      }
    }
    
  }else {
    // Proceed to the route
    next();
  }
})

export default router
